import * as yup from 'yup';

import SelectFormControl from 'components/FormControls/SelectFormControl';
import CheckboxFormControl from 'components/FormControls/CheckboxFormControl';
import { Sort } from 'enums/filters';
import styled, { css } from 'styled-components';
import { InputType } from 'components/common/Input';
import RadioButton from 'components/common/RadioButton';
import FormControl from 'components/FormControls/FormControl';

const StyledFormControl = styled(FormControl)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 1rem 0.75rem;

  ${({ theme }) => css`
    color: ${theme.colors.darkerGray};
    caret-color: ${theme.colors.darkerGray};
    font-size: ${theme.fonts.primary.size.xl};
    vertical-align: middle;
  `}

  &::placeholder {
    color: ${({ theme }) => theme.colors.mediumGray};
  }

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    ${({ theme }) =>
      ` -webkit-box-shadow: 0 0 0 30px ${theme.colors.white} inset !important;
    -webkit-text-fill-color: ${theme.colors.darkerGray};
    -webkit-text-size-adjust: ${theme.fonts.primary.size.xl};`}
  }
`;

export const filtersToDealershipTableFields = [
  {
    name: 'oems',
    label: 'OEMs',
    placeholder: 'OEMs',
    FormControl: SelectFormControl,
    isMulti: true,
  },
  {
    name: 'mustIncludeAllOems',
    label: 'All selected OEMs must be included',
    FormControl: CheckboxFormControl,
  },
  {
    label: 'Sort by name',
    name: 'sorting',
    type: InputType.Radio,
    Control: RadioButton,
    FormControl: StyledFormControl,
    controllersContainerStyle: css`
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 0.5rem;

      ${({ theme }) =>
        css`
          @media screen and (min-width: ${theme.mediaQueries.tablet}) {
            gap: 3rem;
          }
        `}
    `,
    controllers: [
      {
        value: Sort.Ascending,
        label: 'A to Z',
      },
      {
        value: Sort.Descending,
        label: 'Z to A',
      },
    ],
  },
];

export const validationSchema = yup.object().shape({
  oems: yup.array().nullable(),
  mustIncludeAllOems: yup.bool().nullable(),
});
